// Spinner.jsx
import React from "react";
import '../../Stylesheets/Public/Spinner.css'

const Spinner = ({ size = 32, label = "Loading…", inline = false }) => {
  const style = { ['--sz']: `${size}px` };
  return (
    <div className={`spin ${inline ? 'spin-inline' : ''}`} style={style} role="status" aria-live="polite">
      <span className="sr-only">{label}</span>
    </div>
  );
};

export default Spinner;
